"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  CreditCard,
  BarChart3,
  ArrowRight,
  ChevronRight,
  DollarSign,
  TrendingUp,
} from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
// import Image from "next/image";
import cuentas from "../../assets/cuentas.png";
export default function Hero() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <section className="pt-28 pb-20 md:pt-32 md:pb-24 relative overflow-hidden">
      {/* Background gradient effects */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-chart-1/20 rounded-full blur-3xl dark:bg-chart-1/10" />
      <div className="absolute top-1/2 -right-24 w-96 h-96 bg-chart-2/20 rounded-full blur-3xl dark:bg-chart-2/10" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="space-y-6"
            >
              <div className="inline-flex items-center gap-2 bg-muted px-4 py-2 rounded-full text-sm">
                <span className="flex items-center gap-1.5">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-chart-1 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-chart-1"></span>
                  </span>
                  Nuevo
                </span>
                <span className="inline-block">
                  Soporte para múltiples monedas 🇵🇪
                </span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
                <span className="block">Gestión financiera</span>
                <span className="bg-gradient-to-r from-chart-1 via-chart-2 to-chart-4 text-transparent bg-clip-text">
                  inteligente y simple
                </span>
              </h1>

              <p className="text-lg md:text-xl text-muted-foreground max-w-lg">
                Controla todas tus finanzas en un solo lugar. Diseñado
                especialmente para freelancers, empresas y MYPEs en Perú.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-2">
                <a
                  className="bg-gradient-to-r from-chart-1 to-chart-2 hover:from-chart-1/90 hover:to-chart-2/90 text-white flex p-3 border-radius-3 items-center rounded-sm"
                  href="#precios"
                >
                  Comenzar gratis
                  <ArrowRight className="ml-2 h-4 w-4" />
                </a>
                {/* <Button variant="outline" size="lg">
                  Ver demostración
                  <ChevronRight className="ml-2 h-4 w-4" />
                </Button> */}
              </div>

              {/* <div className="pt-6">
                <p className="text-sm text-muted-foreground mb-3">
                  Confían en nosotros:
                </p>
                <div className="flex flex-wrap gap-6 items-center">
                  <div className="text-muted-foreground/70 dark:text-muted-foreground/50 text-sm font-medium">
                    Empresa A
                  </div>
                  <div className="text-muted-foreground/70 dark:text-muted-foreground/50 text-sm font-medium">
                    Empresa B
                  </div>
                  <div className="text-muted-foreground/70 dark:text-muted-foreground/50 text-sm font-medium">
                    Empresa C
                  </div>
                  <div className="text-muted-foreground/70 dark:text-muted-foreground/50 text-sm font-medium">
                    Empresa D
                  </div>
                </div>
              </div> */}
            </motion.div>
          </div>

          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative"
            >
              <div className="bg-gradient-to-br from-card/50 to-card border rounded-2xl shadow-xl p-1 dark:from-card/30 dark:border-muted/30 backdrop-blur">
                <div className="rounded-xl overflow-hidden bg-gradient-to-br from-card to-background">
                  <div className="relative  w-full">
                    <img
                      src={cuentas}
                      alt="Dashboard de Finanza.lat"
                      fill
                      className="object-cover rounded-t-xl"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent rounded-t-xl"></div>

                    {/* Floating elements */}
                    <div className="absolute top-12 left-6 animate-float">
                      <div className="bg-card border shadow-lg p-4 rounded-lg max-w-[180px]">
                        <div className="flex items-center gap-2">
                          <CreditCard className="h-5 w-5 text-chart-1" />
                          <span className="text-sm font-medium">
                            Cuenta BCP
                          </span>
                        </div>
                        <p className="text-xl font-bold mt-1">S/. 4,280.50</p>
                        <div className="flex items-center gap-1 text-xs text-green-500 mt-1">
                          <TrendingUp className="h-3 w-3" />
                          <span>+12% este mes</span>
                        </div>
                      </div>
                    </div>

                    <div className="absolute bottom-20 right-6 animate-float-delayed">
                      <div className="bg-card border shadow-lg p-4 rounded-lg max-w-[180px]">
                        <div className="flex items-center gap-2">
                          <BarChart3 className="h-5 w-5 text-chart-2" />
                          <span className="text-sm font-medium">Ingresos</span>
                        </div>
                        <p className="text-xl font-bold mt-1">$1,425.00</p>
                        <div className="flex items-center gap-1 text-xs text-green-500 mt-1">
                          <TrendingUp className="h-3 w-3" />
                          <span>+8% vs anterior</span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="absolute top-1/2 left-1/3 animate-pulse">
                      <div className="flex items-center gap-1.5 bg-card/90 backdrop-blur border shadow px-3 py-1.5 rounded-full">
                        <DollarSign className="h-4 w-4 text-chart-4" />
                        <span className="text-xs font-medium">
                          Cambio: S/. 3.70
                        </span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
